<template>
    <div class="privacy-flags">
        <table>
            <tbody>
                <template v-for="t in paragraph.treatments">
                    <privacy-flag :flag="t" :key="t.id" :pargraph="paragraph"/>
                </template>
            </tbody>
        </table>
    </div>
</template>

<script>
import PrivacyFlag from './PrivacyFlag'

export default {
  name: 'PrivacyParagraphFlags',
  components: {
    PrivacyFlag
  },
  props: ['paragraph']
}
</script>



// WEBPACK FOOTER //
// src/components/PrivacyParagraphFlags.vue